export class ActionTypes {
  static SetInitialMappings = 'SetInitialMappings';
  static SetTimetableCourses = 'SetTimetableCourses';
  static SetCloudCourses = 'SetCloudCourses';
  static UpdateSingleMapping = 'UpdateSingleMapping';
  static SetErrorMessage = 'SetErrorMessage';
  static SetMappingFilter = 'SetMappingFilter';
  static ResetMappings = 'ResetMappings';
  static SetItemsPerPage = 'SetItemsPerPage';
  static SetPage = 'SetPage';
  static SetHasChanges = 'SetHasChanges';
  static ImportMappings = 'ImportMappings';
  static SetImportIssues = 'SetImportIssues';
  static SetAllowMultipleAzureGroupUsage = 'SetAllowMultipleAzureGroupUsage';
}
